import { Button, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Dispatch, SetStateAction } from 'react';
import usePlanStore from '../../../../../../../store/planStore';

interface CountrySetupButtonGroupProps {
  country: string;
  toggleResetDialog: Dispatch<SetStateAction<boolean>>;
  isProceedDisabled: boolean;
  setIsOpenRecalculateTouchpointsModal: Dispatch<SetStateAction<boolean>>;
}

export default function CountrySetupButtonGroup({
  country,
  toggleResetDialog,
  isProceedDisabled,
  setIsOpenRecalculateTouchpointsModal,
}: CountrySetupButtonGroupProps) {
  const { t } = useTranslation();
  const {
    selectedCountry,
    countryForms,
    updateCountryForm,
    saveCountryFormState,
    resetSavedCalculatedBudget,
    resetCalculatedBudget,
    savedCountryForms,
  } = usePlanStore();

  const countryForm = countryForms[selectedCountry!];

  const handleOkButtonClick = () => {
    if (!countryForms[selectedCountry!].isCountrySetupConfirmed) {
      updateCountryForm(country, { isCountrySetupConfirmed: true });
      resetSavedCalculatedBudget(country);
      resetCalculatedBudget(country);
      saveCountryFormState(country);
    } else {
      setIsOpenRecalculateTouchpointsModal(true);
    }
  };

  return (
    <>
      <Grid item xs={8} />
      <Grid
        item
        xs={4}
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: 2,
        }}
      >
        <Button
          variant="text"
          color="primary"
          sx={{ fontWeight: 700 }}
          onClick={() => toggleResetDialog(true)}
          disabled={
            countryForm.metaConfig?.reservationStatus === 'reserved' ||
            countryForm.metaConfig?.reservationStatus === 'partially-reserved'
          }
        >
          {t('Clear form')}
        </Button>
        <Button
          variant="contained"
          color="primary"
          type="submit"
          sx={{ padding: '8px 24px', minWidth: '116px', mr: '6px' }}
          disabled={isProceedDisabled}
          onClick={handleOkButtonClick}
        >
          {t('OK')}
        </Button>
      </Grid>
    </>
  );
}
